import { Injectable } from '@angular/core';
import { AbstractStateService } from '@tnq/shared/core';
import { onboardingWidgetSchema, IOnboardingWidgetState } from '../schemas';

@Injectable({
  providedIn: 'root',
})
export class OnboardingWidgetStateService extends AbstractStateService<IOnboardingWidgetState> {
  protected storageKey = 'tnq-onboarding-widget';
  protected schema = onboardingWidgetSchema;
}
